import React from 'react';
import Rater from 'react-rater';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

import config from '@dom/config';
import { makeUrl } from '@dom/utils';

import { onViewGuideProfile } from '@dom/app/src/actions/analytics';

import { Tooltip } from '../../components';

import { useSelector } from '../../redux';
import { BlurImage, ShowReviews, WhitePanelLayout } from './imports';
import { getGuideDataById, getGuideSearchQuery } from '../../redux/selectors';

import { getLocaleString, openInNewTab } from '../../utils';
import { GUIDE_INSURANCE_COST } from '../../constants';

import './guide.scss';

function Guide(props: Props) {
  const {
    id,
    onViewGuideProfile,
  } = props;
  const {
    reviews,
    fullname,
    profileImages,
    averageRating,
    startingPrice,
    experienceYears,
    languages,
    baseCity,
    livesIn,
    expertiseRegions,
  } = useSelector(getGuideDataById(id));

  const { numberOfDays } = useSelector(getGuideSearchQuery) || {};

  const { large: largeProfileImage, medium: mediumProfileImage } = profileImages || {};
  const { currency, amount } = startingPrice || {};

  const totalCost = Number(numberOfDays || 1) * Number(amount) + GUIDE_INSURANCE_COST || amount;

  const imageStyles = {
    backgroundImage: `url(${config.RESOURCE_URL}/${largeProfileImage})`,
  };

  const goToProfile = (e) => {
    e.stopPropagation();
    onViewGuideProfile();
    openInNewTab(makeUrl.goToGuideProfile(fullname, id));
  }

  const priceBreakDown = `Price for ${numberOfDays || 1} Day${numberOfDays ? 's' : ''} is ${currency} ${getLocaleString(totalCost)}`;
  const tooltipMessage = 'Includes Daily Wages, Insurance, Food and Accommodation Costs. Local transportation is not included.';

  return (
    <div onClick={goToProfile} style={{ cursor: 'pointer' }}>
      <WhitePanelLayout className="grid-view">
        <div className="image-holder" style={imageStyles}>
          <BlurImage
            alt={fullname}
            placeholder={`${config.RESOURCE_URL}/${mediumProfileImage}`}
            src={`${config.RESOURCE_URL}/${largeProfileImage}`}
          />
        </div>
        <div className="information-box">
          <div className="detail-info">
            <div className="detail-holder">
              <h4>{fullname}</h4>
              <p>Experience: {experienceYears ? `${experienceYears} years` : ''}</p>
              <p>Based In: {baseCity || livesIn}</p>
              <p>Language: {languages && languages.join(', ')}</p>
              <div className="d-none d-md-block">
                {
                  expertiseRegions && (
                    <>
                      <p>Expertise Regions:</p>
                      <ul>
                        {/* Render only 2 Expertise Regions Because of Space Constraints in CardsConstraints */}
                        {expertiseRegions.slice(0, 2).map(r => <li key={r}>{r}</li>)}
                      </ul>
                    </>
                  )
                }
              </div>
            </div>
            <div className="price-detail">
              {
                amount && (
                  <>
                    <h4>
                      {currency} {amount}/day
                      </h4>
                    <Tooltip info={tooltipMessage}>
                      <div className="breakdown">
                        <span>{priceBreakDown}</span>
                        <em>i</em>
                      </div>
                    </Tooltip>
                  </>
                )
              }
              {/* <div className="wrap-t">
                  <p className="breakdown" style={{ color: '#e91e63', textAlign:'right', display:'unset'}}>Free Cancellation within 7 days</p>
                </div> */}
              <Rater
                total={5}
                rating={Number(averageRating)}
                interactive={false}
              />
              <ShowReviews numReviews={reviews && reviews.numberOfReviews} />
              <Button color="yellow" size="sm" onClick={goToProfile}>
                View Profile
                </Button>
            </div>
            {/* <div className="detail-holder d-block d-md-none full-flex">
              {
                expertiseRegions && (
                  <>
                    <p>Expertise Regions:</p>
                    <ul>
                      {expertiseRegions.slice(0, 2).map(r => <li key={r}>{r}</li>)}
                    </ul>
                  </>
                )
              }
            </div> */}
          </div>
        </div>
      </WhitePanelLayout>
    </div>
  );
}

export default connect(null, { onViewGuideProfile })(Guide);
